import { render } from "./FooterBaluchonalzheimer.vue?vue&type=template&id=66717ba7&scoped=true"
import script from "./FooterBaluchonalzheimer.vue?vue&type=script&lang=js"
export * from "./FooterBaluchonalzheimer.vue?vue&type=script&lang=js"

import "./FooterBaluchonalzheimer.vue?vue&type=style&index=0&id=66717ba7&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66717ba7"]])

export default __exports__